import { Controller } from "@hotwired/stimulus"

// Opens the GOAT Connect softphone from server-rendered markup, on a given tab
// (#16204: Phone Settings' Record Greeting opens it on its Voicemail tab, where
// the Voicemail Box Greeting is recorded).
//
//   <button data-controller="softphone-open" data-action="softphone-open#open"
//           data-softphone-open-tab-value="voicemail">
//
// The softphone island loads lazily, so a click on a cold page can land before
// it listens. The controller knows the softphone is there once it has answered
// a capability request (it also announces itself when it mounts); a click
// before then is held and delivered on that answer, or dropped after
// READY_TIMEOUT_MS.
//
// The event names are mirrored from app/frontend's softphoneDocumentBridge.ts
// (SOFTPHONE_OPEN_REQUEST_EVENT, the capability pair): this bundle is built by
// esbuild and cannot import the Vite one, so a change to either side must be
// made on both. The page only renders this control where the softphone mounts.
const OPEN_REQUEST_EVENT = "goat:softphone-open-request"
const CAPABILITY_REQUEST_EVENT = "goat:softphone-capability-request"
const CAPABILITY_EVENT = "goat:softphone-capability"
export const READY_TIMEOUT_MS = 10000

let requestSequence = 0

export default class extends Controller {
  static values = { tab: String }

  connect() {
    this.ready = false
    this.pending = false
    this.onCapability = (event) => {
      if (typeof event.detail?.mounted !== "boolean") return
      this.ready = event.detail.mounted
      if (this.ready && this.pending) this.deliver()
    }
    document.addEventListener(CAPABILITY_EVENT, this.onCapability)
    this.askCapabilities()
  }

  disconnect() {
    document.removeEventListener(CAPABILITY_EVENT, this.onCapability)
    window.clearTimeout(this.giveUp)
  }

  open(event) {
    event.preventDefault()
    if (this.ready) {
      this.deliver()
      return
    }
    // Not answered yet: hold the click until the softphone is listening.
    this.pending = true
    window.clearTimeout(this.giveUp)
    this.giveUp = window.setTimeout(() => { this.pending = false }, READY_TIMEOUT_MS)
    this.askCapabilities()
  }

  deliver() {
    this.pending = false
    window.clearTimeout(this.giveUp)
    const detail = this.tabValue ? { tab: this.tabValue } : {}
    document.dispatchEvent(new CustomEvent(OPEN_REQUEST_EVENT, { detail }))
  }

  askCapabilities() {
    requestSequence += 1
    document.dispatchEvent(new CustomEvent(CAPABILITY_REQUEST_EVENT, {
      detail: { requestId: `open-capability-${requestSequence}` },
    }))
  }
}
